var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from 'react';
import * as ServiceAffaire from '../../services/affaire';
import { EditionAffaire } from './EditionAffaire';
import { Document } from '../document/Document';
import { Loader } from '../../utils/Loader';
import { Link } from '../../utils/Link';
import { Card, Divider, Stack, Tab, Tabs, Chip, Grid, Box, Tooltip, } from '@mui/material';
import { CardTitle } from '../../utils/CardTitle';
import { AffaireIcon, ClientIcon, CopyIcon, DeleteIcon, StopIcon, LooseIcon, EditIcon, OpenIcon, } from '../../utils/Icons';
import { Definitions } from '../../utils/Definitions';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { Stepper } from '../../utils/Stepper';
import { Snackbar } from '../../utils/Snackbar';
import moment from 'moment';
import { formatNumber } from '../../services/utils/utils';
import { Equipe } from '../equipe/Equipe';
import { Offre } from '../offre/Offre';
import { GenerateurDocumentAffaire } from './GenerateurDocumentAffaire';
import { colorEtatClient, getColor, getColors, } from '../../utils/Classes';
import { Button } from '../../utils/Button';
import { converYearMonthToString } from '../../services/dashboard';
import { Error, isError } from '../error/Error';
import { Typography } from '../../utils/Typography';
import { getIsMobile, getOriginalUser } from '../../services/utilisateur';
import { TYPES_EQUIPE } from '../equipe/EditionEquipe';
import { MapRedirection } from '../../utils/MapData';
import { ClonerAffaire } from './ClonerAffaire';
var originalUser = getOriginalUser();
export var FicheAffaire = function (props) {
    var AffaireId = props.AffaireId;
    var isMobile = getIsMobile();
    var palette = getColors();
    var _a = useState(0), navigationSelected = _a[0], setNavigationSelected = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), affaire = _c[0], setAffaire = _c[1];
    var _d = useState(false), openModification = _d[0], setOpenModification = _d[1];
    var _e = useState(false), showModalClone = _e[0], setShowModalClone = _e[1];
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var newAffaire;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceAffaire.getAffaire(AffaireId)];
                case 1:
                    newAffaire = _a.sent();
                    setAffaire(newAffaire);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [AffaireId]);
    useEffect(function () {
        getData();
    }, []);
    if (!affaire || loading) {
        return _jsx(Loader, {});
    }
    if (isError(affaire)) {
        return _jsx(Error, __assign({}, affaire));
    }
    var isCloture = !affaire || affaire.Etat !== 'E';
    var handleClickStepper = function (etape, Etat) {
        if (Etat === void 0) { Etat = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation, isOk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isCloture) {
                            return [2 /*return*/];
                        }
                        if (!Etat) return [3 /*break*/, 2];
                        return [4 /*yield*/, ConfirmDialog({
                                title: 'Confirmation',
                                content: "Cl\u00F4turer l'affaire en \"".concat(affaire.getEtats[Etat], "\" ?"),
                                color: Etat === 'C' ? 'affaire' : 'error',
                            })];
                    case 1:
                        confirmation = _a.sent();
                        if (!confirmation.isOk) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, ServiceAffaire.postEtapeAffaire(AffaireId, etape, Etat)];
                    case 3:
                        isOk = (_a.sent()).isOk;
                        if (isOk) {
                            getData();
                            Snackbar({ message: 'Sauvegardé avec succès' });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleReouvrirAffaire = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Confirmation',
                        content: "Êtes vous sûr de vouloir réouvrir l'affaire ?",
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceAffaire.reouvrirAffaire(AffaireId)];
                case 2:
                    _a.sent();
                    getData();
                    Snackbar({ message: 'Affaire réouverte' });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderAffaire = function () {
        var adresse = [
            affaire.client.Adresse,
            affaire.client.CodePostal,
            affaire.client.Ville,
            affaire.client.intitule_pays ? affaire.client.intitule_pays.Libelle : '',
        ]
            .filter(function (value) { return value; })
            .join(' ');
        return (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsxs(Grid, __assign({ container: true, spacing: isMobile ? 0 : 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 4, pr: 1 }, { children: _jsx(Definitions, { datas: __spreadArray(__spreadArray([
                                {
                                    label: (_jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Chip, { label: affaire.client.getEtatLibelle, color: colorEtatClient(affaire.client.Etat) }) }))),
                                    value: (_jsx(Link, { title: affaire.client.getLibelle, color: "client", to: '/client/fiche/' + affaire.client.IdClient, icon: _jsx(ClientIcon, {}) })),
                                }
                            ], (affaire.client.IsSociete
                                ? [
                                    {
                                        label: 'Siret',
                                        value: affaire.client.Siret,
                                    },
                                ]
                                : [
                                    {
                                        label: 'Email',
                                        value: affaire.client.Email,
                                    },
                                    {
                                        label: 'Téléphone',
                                        value: affaire.client.Telephone,
                                    },
                                    {
                                        label: 'Mobile',
                                        value: affaire.client.Mobile,
                                    },
                                ]), true), [
                                {
                                    label: 'Adresse',
                                    value: (_jsx(_Fragment, { children: adresse && (_jsx(Typography, __assign({ className: "text-smaller", startIcon: _jsx(MapRedirection, { queries: [adresse] }) }, { children: adresse }))) })),
                                },
                            ], false) }) })), _jsx(Divider, { orientation: "vertical", flexItem: true, sx: { mr: -1 } }), _jsx(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: _jsx(Definitions, { datas: [
                                {
                                    label: 'Type',
                                    value: affaire.affaire_type
                                        ? affaire.affaire_type.Libelle
                                        : '-',
                                },
                                {
                                    label: 'Créé le',
                                    value: affaire.createdAt
                                        ? moment(affaire.createdAt).format('DD/MM/YYYY')
                                        : '-',
                                },
                                {
                                    label: 'Date début',
                                    value: affaire.DateDebut
                                        ? "".concat(moment(affaire.DateDebut).format('DD/MM/YYYY'))
                                        : '-',
                                },
                                {
                                    label: 'Date fin',
                                    value: affaire.DateFin
                                        ? "".concat(moment(affaire.DateFin).format('DD/MM/YYYY'))
                                        : '-',
                                },
                                {
                                    label: 'Date de clôture',
                                    value: affaire.DateCloture
                                        ? moment(affaire.DateCloture).format('DD/MM/YYYY HH:mm')
                                        : '-',
                                },
                            ] }) })), _jsx(Divider, { orientation: "vertical", flexItem: true, sx: { mr: -1 } }), _jsx(Grid, __assign({ item: true, xs: 12, md: 4, pr: 1 }, { children: _jsx(Definitions, { datas: __spreadArray([
                                {
                                    label: 'Probabilité',
                                    value: affaire.probabilite
                                        ? affaire.probabilite.Libelle
                                        : '-',
                                },
                                {
                                    label: 'Signature',
                                    value: affaire.MoisSignature
                                        ? converYearMonthToString(affaire.MoisSignature)
                                        : '-',
                                },
                                {
                                    label: 'Tarif',
                                    value: formatNumber(affaire.TotalTarif, '€'),
                                },
                                {
                                    label: 'Marge',
                                    value: formatNumber(affaire.TotalMarge, '€'),
                                },
                                {
                                    label: 'Coût',
                                    value: formatNumber(affaire.TotalTarif - affaire.TotalMarge, '€'),
                                }
                            ], (isMobile
                                ? [
                                    {
                                        label: 'Offres',
                                        valueUnder: true,
                                        value: (_jsx(Stack, { children: affaire.offres.map(function (offre) {
                                                if (offre.catalogue) {
                                                    return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ variant: "body1" }, { children: offre.Designation })), _jsxs(Typography, __assign({ className: "ml-small", sx: { fontStyle: 'italic' }, variant: "body2" }, { children: ["(", offre.Quantite, offre.Unite ? " ".concat(offre.Unite) : '', ")"] }))] }), offre.IdOffre));
                                                }
                                            }) })),
                                    },
                                ]
                                : []), true) }) }))] })) })));
    };
    var renderTitle = function () {
        return (_jsx(CardTitle, { withFileAriane: true, datas: {
                ClientId: affaire.ClientId,
                AffaireId: affaire.IdAffaire,
                ClientName: affaire.client.getLibelle,
                AffaireName: affaire.getLibelle,
            }, color: "affaire", startIcon: _jsx(AffaireIcon, {}), renderButtons: function () { return (_jsxs(Stack, __assign({ direction: isMobile ? 'column' : 'row', spacing: 2, alignItems: "center" }, { children: [affaire.TagsObject &&
                        affaire.TagsObject.map(function (tag) { return (_jsx(Chip, { color: "info", label: tag.label }, tag.value)); }), !!affaire.IsLectureSeule && (_jsx(Tooltip, __assign({ disableInteractive: true, title: affaire.IsLectureSeule }, { children: _jsx(Chip, { className: "bold", color: "warning", label: "Affaire non modifiable" }) }))), !affaire.IsLectureSeule && (_jsxs(_Fragment, { children: [_jsxs(Button, __assign({ size: "small", color: "error", onClick: function () { return handleClickStepper(null, 'P'); }, endIcon: _jsx(LooseIcon, {}) }, { children: [affaire.getEtats['P'], " ?"] })), _jsxs(Button, __assign({ size: "small", color: "error", onClick: function () { return handleClickStepper(null, 'A'); }, endIcon: _jsx(StopIcon, {}) }, { children: [affaire.getEtats['A'], " ?"] })), _jsx(Button, __assign({ size: "small", color: "primary", onClick: function () { return setOpenModification(true); }, endIcon: _jsx(EditIcon, {}) }, { children: "Modifier" })), openModification && (_jsx(EditionAffaire, { AffaireId: affaire.IdAffaire, handleClose: function () {
                                    setOpenModification(false);
                                    getData();
                                } }))] }))] }))); } }));
    };
    var displayDiffMontant = function (montantActuel, montantPrevisionnel) {
        return (_jsx(_Fragment, { children: montantPrevisionnel !== null &&
                montantActuel !== montantPrevisionnel ? (_jsxs("div", __assign({ className: "flex" }, { children: [_jsx(Box, __assign({ className: "absolute text-smaller", sx: {
                            color: getColor(palette, 'error'),
                            fontStyle: 'italic',
                            textDecoration: 'line-through',
                            right: 0,
                            top: 0,
                        } }, { children: formatNumber(montantActuel, '€') })), formatNumber(montantPrevisionnel, '€')] }))) : (formatNumber(montantActuel, '€')) }));
    };
    var renderHeader = function () {
        var etapes = [];
        var valueEtape = affaire.Etape !== null ? parseInt(affaire.Etape) : affaire.Etat;
        for (var _i = 0, _a = affaire.getEtapes; _i < _a.length; _i++) {
            var etape = _a[_i];
            etape.Date =
                etape.FieldDate && affaire[etape.FieldDate]
                    ? affaire[etape.FieldDate]
                    : null;
            if (affaire.Etape !== null) {
                etapes.push(etape);
                continue;
            }
            if (affaire[etape.FieldDate]) {
                if (affaire.Etape === null) {
                    if (etape.GoCloture) {
                        etapes.push({
                            Id: affaire.Etat,
                            Libelle: affaire.getEtats[affaire.Etat],
                        });
                    }
                    else {
                        etapes.push(etape);
                    }
                }
            }
        }
        return (_jsx(Stack, __assign({ spacing: 4, alignItems: "center", className: "mt-small" }, { children: _jsx(Stepper, { steps: etapes, value: valueEtape, onClick: handleClickStepper, disabled: !!affaire.IsLectureSeule }) })));
    };
    var handleClickDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: "Êtes vous sûr de vouloir supprimer l'affaire ?",
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceAffaire.deleteAffaire(AffaireId)];
                case 2:
                    _a.sent();
                    window.history.back();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOffresChange = function (offres) {
        var newAffaire = __assign(__assign({}, affaire), { offres: offres });
        newAffaire.TotalTarif = 0;
        newAffaire.TotalMarge = 0;
        for (var _i = 0, offres_1 = offres; _i < offres_1.length; _i++) {
            var offre = offres_1[_i];
            newAffaire.TotalTarif += offre.TotalTarif;
            newAffaire.TotalMarge += offre.TotalMarge;
        }
        setAffaire(newAffaire);
    };
    var renderOffre = function () {
        return (_jsxs(_Fragment, { children: [affaire.Commentaire && (_jsx(Definitions, { datas: [
                        {
                            label: 'Commentaire',
                            value: _jsx("p", __assign({ className: "pre-line" }, { children: affaire.Commentaire })),
                            valueUnder: true,
                        },
                    ] })), affaire.Details && (_jsx(Definitions, { datas: [
                        {
                            label: 'Détails',
                            value: _jsx("p", __assign({ className: "pre-line" }, { children: affaire.Details })),
                            valueUnder: true,
                        },
                    ] })), _jsx(Offre, { AffaireId: AffaireId, canEdit: !affaire.IsLectureSeule, onChange: handleOffresChange })] }));
    };
    var TABS = [
        {
            label: 'Informations',
            component: function () { return (_jsxs(_Fragment, { children: [renderAffaire(), !isMobile && renderOffre(), _jsx(Card, __assign({ variant: "outlined" }, { children: _jsxs(Stack, __assign({ justifyContent: "center", alignItems: "center", direction: "row", padding: 2, spacing: 2 }, { children: [isCloture && (_jsx(Button, __assign({ color: "primary", onClick: function () { return handleReouvrirAffaire(); }, startIcon: _jsx(OpenIcon, {}) }, { children: "R\u00E9ouvrir l'affaire" }))), _jsx(Button, __assign({ color: "primary", onClick: function () { return setShowModalClone(true); }, startIcon: _jsx(CopyIcon, {}) }, { children: "Cl\u00F4ner l'affaire" })), showModalClone && (_jsx(ClonerAffaire, { AffaireId: AffaireId, DefaultClientId: affaire.ClientId, DefaultMoisSignature: affaire.MoisSignature, handleClose: function () { return setShowModalClone(false); } })), !affaire.IsLectureSeule && (_jsx(Button, __assign({ color: "error", onClick: function () { return handleClickDelete(); }, startIcon: _jsx(DeleteIcon, {}) }, { children: "Supprimer l'affaire" })))] })) }))] })); },
            refreshDatas: !isMobile,
            show: true,
        },
        {
            label: 'Offres',
            component: function () { return renderOffre(); },
            refreshDatas: true,
            show: isMobile,
        },
        {
            label: 'Équipe',
            component: function () { return (_jsx(Equipe, { ObjetId: AffaireId, ObjetType: TYPES_EQUIPE.AFFAIRE, CanEditEquipe: !affaire.IsLectureSeule })); },
            show: originalUser.Licence.UseVision,
        },
        {
            label: 'Documents',
            component: function () { return (_jsx(Document, { Model: "Affaire", ModelId: AffaireId, CanEditDocument: !affaire.IsLectureSeule })); },
            show: originalUser.Licence.UseDocument,
        },
        {
            label: 'Générateur',
            component: function () { return (_jsx(GenerateurDocumentAffaire, { ClientId: affaire.ClientId, AffaireId: AffaireId })); },
            refreshDatas: true,
            show: true,
        },
    ].filter(function (tab) { return tab.show; });
    return (_jsxs(_Fragment, { children: [renderTitle(), renderHeader(), _jsx(Tabs, __assign({ variant: "scrollable", allowScrollButtonsMobile: true, value: navigationSelected, onChange: function (e, newValue) {
                    if (TABS[navigationSelected].refreshDatas) {
                        getData();
                    }
                    setNavigationSelected(newValue);
                } }, { children: TABS.map(function (tab) { return (_jsx(Tab, { label: tab.label }, tab.label)); }) })), TABS[navigationSelected].component()] }));
};
//# sourceMappingURL=FicheAffaire.js.map